module.exports = __webpack_public_path__ + "static/media/aryanvijaywargia.7146785f.jpeg";